import L from 'leaflet';
import map_dosha_base from './map_dosha_base';
/**
 * 土砂災害地図表示用クラス
 */
export default class map_dosha_sp extends map_dosha_base {
    /**
     * コンストラクタ
     */
    constructor(mapElement, mapPos) {
        super(mapElement, mapPos);
        this.setSoilWaterIndexStandardTable();
    }
    /**
     * 初期化処理
     */
    Initilize() {
        this.setMeshLayer();
    }
    /**
     * メッシュレイヤの作成（ベクトルタイル版）
     */
    createLayer() {
        let url = dosya_1kmesh_env.mesh1kVectorGrid;
        // スマホの場合ベクトルタイル
        let layer = L.vectorGrid.protobuf(url, {
            maxZoom: 17,
            interactive: true,
            rendererFactory: L.canvas.tile,
            vectorTileLayerStyles: {
                // TODO メッシュデータのプロパティ名がwakayama1k_all_jogaiになっているのでいったんそのまま。
                // saitamaに修正されたものが来たらプロパティ名を変更する
                wakayama1k_all_jogai: (properties, zoom) => {
                    let mesh = properties.code;
                    return (this.getMeshStyle(mesh));
                }
            }
        });
        layer.on('click', (e) => {
            if (e.layer.properties) {
                this.onMeshClick(e.layer.properties);
            }
        });
        return layer;
    }
}
